<template>

	<myframe v-if="rows" without_border without_margin title="Затратный подход">

		<biTable class="mt-4" :data="rows">
			<template v-slot:value_params="row">
				<router-link v-if="row.data.title == 'Модель оценки КС'" :to="row.data.value.url">{{ row.data.value.full_name }}</router-link>
			</template>
		</biTable>

	</myframe>

</template>

<script>

import api from "../../../../../api";
import myframe from "../../../../widgets/frame"
import biTable from "../../../../widgets/bi-table"

export default
{
	props:
	{
		version: Object,
	},

	components:
	{
		myframe,
		biTable
	},

	data() {
		return {

			service: "cadastral_objects",

			rows : null

		}
	},

	mounted()
	{
		const rows = [
			{ title: 'Метод', value : this.version.group.cost_evaluation_expensive.type },
			{ title: 'Код объекта-аналога', value : this.version.attrs.code_of_analogue_expensive },
			{ title: 'УПКС', value : api.format_cost(this.version.attrs.UPKS_expensive) },
			{ title: 'Кадастровая стоимость', value : api.format_cost(this.version.attrs.cost_expensive) },
			{
				title: 'Модель оценки КС',
				value :
				{
					url : '/cost_evaluations/' + this.version.group.id + '/expensive',
					full_name : 'Затратный подход'
				},
				params : true
			},
		]

		this.rows = rows

		if (this.version.attrs.UPKS_expensive && this.version.attrs.cost_expensive) {
			const params = {
				"field" : "obj.name",
				"value" : this.version.attrs.CadastralNumber
			}

			api.call(this, "cadastral_expensive_details", "get_by", params,
				(response) => {
					const info = response.data.info

					rows.splice(3, 0, { title: 'Прибыль предпринимателя', value : api.number_to_string_with_ranking(info.AE) })
					rows.splice(4, 0, { title: 'Совокупный износ', value : info.AM,})

					this.rows = rows
				}
			)
		}
	},

	methods:
	{
	}
}

</script>
